import React from 'react';
import { Layout, Button, ConfigProvider } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import ls from 'local-storage';
import { TopHeader, NavMenu, RecognitionNotice } from '../../components';
import iconLeft from '../../assets/icons/icon-arrow-left.svg';
import styles from './styles.less';
import { ACTION_APP_GO_TO_ROUTE } from '../../models/app';
import { ROUTE_LEAD_VISITS } from '../../routes';
import Loader from '../Loader';

const { Sider, Content } = Layout;
export const LS_MENU_COLLAPSED_KEY = 'MENU_COLLAPSED';

const renderEmpty = () => (
  <p>
    <FormattedMessage id="Common.NoData" />
  </p>
);

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: ls.get(LS_MENU_COLLAPSED_KEY) || false,
      mobileMenuCollapsed: false,
    };
  }

  onCollapse(collapsed) {
    ls.set(LS_MENU_COLLAPSED_KEY, collapsed);
    this.setState({ collapsed });
  }

  onSelect() {
    const { mobileMenuCollapsed } = this.state;
    if (mobileMenuCollapsed) {
      this.setState({
        mobileMenuCollapsed: false,
      });
    }
  }

  toggleMenu() {
    this.setState({
      mobileMenuCollapsed: !this.state.mobileMenuCollapsed,
      collapsed: false,
    });
  }

  render() {
    const { mobileMenuCollapsed, collapsed } = this.state;
    const content = this.props.children;

    if (!this.props.app.user || !this.props.app.user.id) {
      return <Loader spinning />;
    }

    return (
      <ConfigProvider renderEmpty={renderEmpty}>
        <Layout className={styles.fullHeight}>
          <Button
            className={`tablet-show ${mobileMenuCollapsed ? 'mobile-open' : 'mobile-close'} ${styles.mobileToggle}`}
            size="large"
            type="primary"
            onClick={this.toggleMenu.bind(this)}
          >
            <i className={styles.mobileMenuIcon} />
          </Button>
          <Sider
            className={`${styles.sidebar} tablet-hide`}
            width={300}
            collapsible
            collapsed={collapsed}
            onCollapse={this.onCollapse.bind(this)}
            trigger={
              <div className={styles.sidebarTrigger}>
                <img className={styles.sidebarTriggerImg} src={iconLeft} alt="arrow" />
                <FormattedMessage id="Component.Sider.Trigger" />
              </div>
            }
          >
            <Button
              className={styles.logoBtn}
              onClick={() => {
                this.props.dispatch({
                  type: ACTION_APP_GO_TO_ROUTE,
                  payload: {
                    routeName: ROUTE_LEAD_VISITS,
                    projectId: this.props.app.currentProjectId,
                  },
                });
              }}
            >
              <div className={styles.logo} />
            </Button>
            <div className="scrollView">
              <NavMenu collapsed={collapsed} onSelect={this.onSelect.bind(this)} />
            </div>
          </Sider>
          <Layout className={styles.contentLayout}>
            <Content className={styles.content}>
              <TopHeader />
              <RecognitionNotice />
              {content}
            </Content>
          </Layout>
        </Layout>
      </ConfigProvider>
    );
  }
}

export default connect(({ app, loading }) => ({ app, loading }))(injectIntl(Dashboard));



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js